module.exports = __webpack_public_path__ + "static/media/518GriffinStNW_2018-06-05_9.a9ce72f1.jpg";